module.exports = __webpack_public_path__ + "static/assets/cb317a2b69045c85ab5eedc7b65ecbcd.png";